export const QUERY_KEYS = {
    show_transaction: 'show-transaction',
    retry_transaction: 'retry-transaction'
}
